<template>
    <div class="flexsplit">
        <v-textarea
            label="Conteúdo"
            rows="2"
            auto-grow
            :disabled="!enabled"
            v-model="ctn.items.content">
        </v-textarea>
        <!-- <f-editor v-model="ctn.items.content"></f-editor> -->
        <left-slider v-model="ctn.items.slider" :key="current_key" :disabled="!enabled"></left-slider>
    </div>
</template>

<script>
import LeftSlider from '../LeftSlider/LeftSlider';
import FlukeEditor from '../Editor/Editor';

export default {
    props: [ 'disabled' ],
    components: {
        LeftSlider,
        'f-editor': FlukeEditor
    },
    data: function() {
        return {
            ctn: {
                items: {
                    content: '',
                    slider: ''
                }
            },
            current_key: 0,
            enabled: true
        }
    },
    created: function()
    {
        if( this.$props.disabled === true ) this.enabled = false;
        if(this.$attrs.value) {
            this.ctn.items = this.$attrs.value;
        }
        setTimeout(()=>{
            this.ctn.items.content += '.';
            this.ctn.items.content = this.ctn.items.content.slice(0,-1);
        },200);
    },
    methods: {
        getModuleData(){
            return this.ctn.items;
        }
    }
}
</script>

